import React from "react";
import {
  Page,
  Text,
  Document,
  StyleSheet,
  Font,
  View,
} from "@react-pdf/renderer";
import "../../../utilits/helpers/numberToWord";
import "@fontsource/roboto";

Font.register({
  family: "Roboto",
  src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf",
});

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 12,
    textAlign: "center",
    fontFamily: "Roboto",
  },
  titleLeft: {
    fontSize: 12,
    textAlign: "left",
    fontFamily: "Roboto",
    textIndent: "10px",
  },
  text: {
    margin: 5,
    fontSize: 10,
    textAlign: "justify",
    fontFamily: "Roboto",
  },
  textWithIndent: {
    margin: 8,
    fontSize: 10,
    textAlign: "justify",
    fontFamily: "Roboto",
    textIndent: "20px",
  },
  rowText: {
    marginTop: 5,
    fontSize: 12,
    textAlign: "left",
    fontFamily: "Roboto",
  },
  rowTextTitleLeft: {
    marginTop: 5,
    fontSize: 12,
    textAlign: "left",
    fontFamily: "Roboto",
  },
  rowTextTitleRight: {
    marginTop: 5,
    fontSize: 12,
    textAlign: "right",
    fontFamily: "Roboto",
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: "center",
    color: "grey",
    fontFamily: "Roboto",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  row: {
    flex: 1,
    flexDirection: "row",
    flexGrow: 1,
  },
  left: {
    width: "50%",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "auto",
  },
  right: {
    width: "50%",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "auto",
  },
});

const convertToRuFormat = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString("ru-RU");
};

const RaschetPDFFile = ({
  docNumber,
  docDate,
  address,
  k2,
  square,
  category,
  k1,
  k3,
  k4,
  ki,
  kz,
  sum,
  nalog,
  shortOrg,
  autor,
}) => {
  return (
    <Document>
      <Page style={styles.body}>
        <Text style={styles.title}>
          Расчет №{docNumber} от {convertToRuFormat(docDate)}
        </Text>
        <Text style={styles.textWithIndent}>
          1{")"}. Начисления ежегодной арендной платы на земельный участок
          расположенный по адресу г. Кара-Балта, {address}, под целевое
          использование: {k2.title}, который произведен согласно порядка расчета
          ежегодной арендной платы за земельные участки, предоставляемые в
          срочное (временное) пользование, утвержденного постановлением
          Кара-Балтинского городского кенеша от 19.02.2014 года за №4.
        </Text>
        <Text style={styles.titleLeft}>Формула №1:</Text>
        <Text style={styles.titleLeft}>A=C*S*K1*K2*K3*K4, где:</Text>
        <Text style={styles.text}>А - ставка годовой арендной платы;</Text>
        <Text style={styles.text}>
          С - базовая ставка земельного налога несельскохозяйственного
          назначения согласно Налогового Кодекса КР = {category};
        </Text>
        <Text style={styles.text}>
          S - площадь земельного участка = {square} кв.м.;{" "}
        </Text>
        <Text style={styles.text}>
          K1 - коэффициент, определяемый от места расположения земельного
          участка (зоны) = {k1.value};
        </Text>
        <Text style={styles.text}>
          K2 - коэффициент, коммерческого использования = {k2.value};
        </Text>
        <Text style={styles.text}>
          K3 - коэффициент, определяемый в зависимости от сроков предоставления
          земельного участка в срочное (временное) пользование = {k3};
        </Text>
        <Text style={styles.text}>
          K4 - коэффициент, определяемый от общей площади предоставляемого
          земельного участка = {k4.value}.
        </Text>
        <Text style={styles.titleLeft}>
          Расчет: {"C"}*{"S"}*{"K1"}*{"K2"}*{"K3"}*{"K4"} = {sum} сом в год.
        </Text>
        <Text style={styles.text}></Text>
        <Text style={styles.text}></Text>
        <Text style={styles.textWithIndent}>
          2{")"}. Расчет земельного налога несельскохозяйственного назначения:
        </Text>
        <Text style={styles.titleLeft}>
          Формула №2 Согласно Налогового Кодекса Кыргызской Республики
        </Text>
        <Text style={styles.titleLeft}>Н=С*П*Kи*Kз*Kк, где:</Text>
        <Text style={styles.text}>Н - сумма земельного налога;</Text>
        <Text style={styles.text}>
          С - ставка земельного налога = {category};
        </Text>
        <Text style={styles.text}>
          П - площадь земельного участка = {square} кв.м.;
        </Text>
        <Text style={styles.text}>Ки - коэффициент инфляции = {ki.value};</Text>
        <Text style={styles.text}>
          Кз - коэффициент зональности = {kz.value};
        </Text>
        <Text style={styles.text}>
          Кк - коэффициент коммерческого использования = {k2.value};
        </Text>
        <Text style={styles.titleLeft}>
          Расчет: {"C"}*{"П"}*{"Ки"}*{"Кз"}*{"Кк"} = {nalog} сом в год.
        </Text>
        <Text style={styles.text}></Text>
        <Text style={styles.text}></Text>
        <Text style={styles.text}></Text>
        <Text style={styles.text}></Text>
        <View style={styles.row}>
          <View style={styles.rowTextTitleLeft}>
            <Text style={styles.rowText}>Специалист {shortOrg}</Text>
          </View>
          <View style={styles.right}>
            <Text style={styles.rowTextTitleRight}>{autor}</Text>
          </View>
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPage }) => `${pageNumber}`}
          fixed
        />
      </Page>
    </Document>
  );
};

export default RaschetPDFFile;
